export const EMPTY_DATE = -4000000001;
export const timestampFromArray = (array) => {
    const [day = 0, month = 0, year = 0] = array || [];
    const emptyDate = day === 0 && month === 0 && year === 0;
    if (emptyDate) {
        return EMPTY_DATE;
    }
    return new Date(Date.UTC(year, month - 1, day)).getTime() / 1e3;
};
export const arrayFromTimestamp = (timestamp) => {
    const emptyDate = typeof timestamp !== 'number' || timestamp === EMPTY_DATE;
    if (emptyDate) {
        return [0, 0, 0];
    }
    const date = new Date(timestamp * 1e3);
    return [date.getUTCDate(), date.getUTCMonth() + 1, date.getUTCFullYear()];
};
export const trimString = (value = '') => !value ? value : value.trim();
export const lowerCase = (value = '') => !value ? value : value.toLowerCase();
export const normalizeNumber = (value) => value?.replace(/\D/g, '');
export const normalizePhone = (value) => {
    if (value) {
        return value
            .split(/\s/)
            .map((v, i) => (i > 0 ? normalizeNumber(v) : v))
            .join(' ');
    }
};
